import { useEvent } from '~/composables/api/useEvent'
import { useContext } from '~/composables/useContext'
import type { Event } from '~/types/prisma'

// A context saved by an earlier visit is outdated once its event has been
// deleted or closed. Checked once per page load so an admin can still browse
// a closed event after picking it in the context selector.
let staleCheckDone = false

export async function ensureEventContext(preFetchedEvents?: Event[]): Promise<string | null> {
  const { getEventId, setEventId } = useContext()
  const { getAllMy, getPrimary } = useEvent()
  const existing = getEventId()

  if (existing) {
    let events = preFetchedEvents
    if (!events && !staleCheckDone) {
      try {
        events = await getAllMy()
      }
      catch {
        // Unknown status; keep the existing context.
      }
    }
    const storedEvent = events?.find(e => e.id === existing)
    const missing = !!events && !storedEvent
    const closed = !staleCheckDone && storedEvent?.status === 'CLOSED'
    staleCheckDone = true
    if (!missing && !closed)
      return existing
  }

  try {
    const { eventId } = await getPrimary()
    if (eventId) {
      setEventId(eventId)
      return eventId
    }
  }
  catch {
    // Primary lookup failed; fall through to whatever the caller had.
  }

  return existing
}
